module.exports = __webpack_public_path__ + "img/eye.7fe4c085.svg";